import router from 'routers/notification.center.router';
import {setupAjaxConfiguration} from "ajaxSetup";

setupAjaxConfiguration(router).then(() => console.log("Ajax setup done."));